import { Beneficiaire } from '../beneficiaire';
import { ServiceCenter } from '../service-center';
import { MissionPlace } from './mission-place';
import { MissionType } from './mission-type';
import { Specialite } from '../specialite';
import { CareSkill } from '../employee/care-skill';
import { State } from '../../enums/state.enum';
import { Mission } from './mission';
import { CenterDepartment } from '../center-department';
import { Address } from '../address';

export class MissionRequest {
	readonly id: number;
	date: Date;
	readyTime: number;
	dueTime: number;
	duration: number;
	notes: string;
	nombreIntervenant: number;
	beneficiaire: Beneficiaire;
	parcoursId: string;
	careSkills: CareSkill[];
	careSpecialty: Specialite;
	serviceCenter: ServiceCenter;
	missionPlace: MissionPlace;
	missionType: MissionType;
	assignedToPlanning: boolean;
	isPartOfAGroup: boolean;
	state: State;
	preparationTimePercentage: number;
	remote: boolean;
	remoteLink: string;
	reminderStatus: string;
	centerDepartment: CenterDepartment;
	departureAddress: Address;

	constructor(
		options: {
			date?: Date;
			readyTime?: number;
			dueTime?: number;
			duration?: number;
			notes?: string;
			nombreIntervenant?: number;
			preparationTimePercentage?: number;

			beneficiaire?: Beneficiaire;
			careSkills?: CareSkill[];
			careSpecialty?: Specialite;
			serviceCenter?: ServiceCenter;
			missionPlace?: MissionPlace;
			missionType?: MissionType;
			assignedToPlanning?: boolean;
			state?: State;
			centerDepartment?: CenterDepartment;
		} = {}
	) {
		this.date = options.date || null;
		this.readyTime = options.readyTime || null;
		this.dueTime = options.dueTime || null;
		this.preparationTimePercentage = options.preparationTimePercentage || 0;
		this.duration = options.duration || null;
		this.notes = options.notes || null;
		this.nombreIntervenant = options.nombreIntervenant || null;
		this.beneficiaire = options.beneficiaire || null;
		this.careSkills = options.careSkills || [];
		this.careSpecialty = options.careSpecialty || null;
		this.serviceCenter = options.serviceCenter || null;
		this.missionPlace = options.missionPlace || null;
		this.missionType = options.missionType || null;
		this.assignedToPlanning = options.assignedToPlanning || false;
		this.state = options.state || State[State.UNDER_REVIEW];
		this.centerDepartment = options.centerDepartment || null;
	}
}
